






































































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import IClose from '@/components/icons/IClose.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import UserAgreement from '@/components/UI/UserAgreement.vue';

import IFlagRu from '@/components/icons/IFlagRu.vue'
import IFlagEn from '@/components/icons/IFlagEn.vue'
import IFlagDe from '@/components/icons/IFlagDe.vue'
import {namespace} from "vuex-class";

const resources = namespace('resources')
const app = namespace('app')
const dialog = namespace('dialog')

@Component({
  components: {
    IClose,
    BtnDefault,
    UserAgreement,
    IFlagRu,
    IFlagEn,
    IFlagDe,
  }
})
export default class SupportDialog extends Vue {
  @Prop({type: Boolean, default: false}) protected dialog!: any
  @Prop({type: String, default: ''}) protected reason!: any
  @Prop({type: Boolean, default: false}) protected isCode!: any
  @Prop({type: String, default: ''}) protected title!: any
  @Prop({type: String, default: ''}) protected text!: any

  @resources.Getter('getCountries') protected getCountries: any
  @app.Action('sendMailToSupport') protected sendMailToSupport: any

  @dialog.Getter('supportDialogOption') protected supportDialogOption: any
  @dialog.Getter('supportDialogShow') protected supportDialogShow: any
  @dialog.Getter('supportDialogTitle') protected supportDialogTitle: any
  @dialog.Getter('supportDialogSubtitle') protected supportDialogSubtitle: any
  @dialog.Mutation('setSupportDialog') protected setSupportDialog: any



  get codes() {
   return  this.getCountries.map((el: any) => {
      return {
        code: '+' + el.phoneCode,
        flagIcon: el.flagIcon
      }
    })
  }

  code: string = ''
  phone: string = ''
  dialogEmail: string = localStorage['lfs-email'] || ''
  dialogName: string = ''
  dialogCompany: string = ''
  dialogQuestion: string = ''
  dialogLoading: boolean = false
  dialogChecked: boolean = false
  isDialogEmailError: boolean = false
  isDialogCodeError: boolean = false
  isDialogPhoneError: boolean = false
  isDialogPhoneErrorValid: boolean = false
  isDialogNameError: boolean = false
  isDialogEmailErrorValid: boolean = false
  isDialogCheckedError: boolean = false
  isShowAgreement: boolean = false

  mounted() {
    this.phone = localStorage.getItem('lfs-phone') || ''
    this.code = localStorage.getItem('lfs-code') || ''
  }

  resetErrors() {
    this.isDialogEmailError = false
    this.isDialogPhoneError = false
    this.isDialogPhoneErrorValid = false
    this.isDialogEmailErrorValid = false
    this.isDialogNameError = false
  }

  validEmail() {
    let re = /^[\w-\.]+@[\w-]+\.[a-z]{2,4}$/i;
    return re.test(this.dialogEmail)
  }
  clear(){
    this.code = localStorage['lfs-code'] || ''
    this.phone = localStorage['lfs-phone'] ||''
    this.dialogEmail = localStorage['lfs-email'] || ''
    this.dialogName = ''
    this.dialogCompany = ''
    this.dialogQuestion = ''
    this.dialogChecked = false
    this.resetErrors()
  }

  validPhone() {
    let re = /^[\d\+][\d\(\)\ -]{4,20}\d$/
    return re.test(this.phone)
  }

  checkName() {
    this.dialogName = this.dialogName.replace(/[^a-zа-яё\s]/gi, '');
  }

  closeModal() {
    this.setSupportDialog(false)
    this.clear()
  }

  changeCheck() {
    this.dialogChecked = !this.dialogChecked
    this.isDialogCheckedError = false
  }

  sendToSupport() {
    this.dialogLoading = true
      let flag = false
      if (this.dialogEmail) {
        this.isDialogEmailErrorValid = !this.validEmail()
      }
      if (this.code && this.phone) {
        this.isDialogPhoneErrorValid = !this.validPhone()
      }
      this.isDialogEmailError = !this.dialogEmail && (!this.code || !this.phone)
      this.isDialogCodeError = !this.code && !this.dialogEmail
      this.isDialogPhoneError = !this.phone && !this.dialogEmail
      this.isDialogNameError = !this.dialogName
      this.isDialogCheckedError = !this.dialogChecked
      flag = ((this.isDialogEmailError || this.isDialogEmailErrorValid) || (this.isDialogPhoneError || this.isDialogCodeError || this.isDialogPhoneErrorValid)) || this.isDialogNameError || this.isDialogCheckedError
      this.dialogLoading = false
      if (!flag) {
        this.sendMailToSupport({
          "name": this.dialogName,
          "email": this.dialogEmail || '',
          "companyTitle": this.dialogCompany,
          "phone": this.phone || '',
          "comment":this.dialogQuestion,
          reason:this.supportDialogOption
        })
        this.clear()
        this.closeModal()
        this.resetErrors()
      }

  }

}

